module.exports = __webpack_public_path__ + "static/img/RWA1566-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA1566-G_1.png
// module id = f52l
// module chunks = 0